interface StorageData {
  value?: any;
  expire?: number;
  version: string;
}

// 版本号进行统一更新
const VERSION = 'vision_10000';

class Storage {
  private version: string;
  constructor({ version }: { version: string }) {
    this.version = version;
  }
  public getStorage(key: string) {
    if (!key) {
      return null;
    }
    const storage: StorageData = this.getPureStorage(key);

    if (!storage) return null;

    if (storage?.version !== this.version) {
      this.removeStorage(key);
      return null;
    }

    if (storage.expire && storage.expire < Date.now()) {
      this.removeStorage(key);
      return null;
    }

    return storage.value;
  }

  public setStorage(key: string, value: any, expire = 0) {
    if (!key) {
      return null;
    }

    const data: StorageData = {
      value,
      expire,
      version: this.version,
    };

    window.localStorage.setItem(key, JSON.stringify(data));
  }

  public updateStorage(key, value: any) {
    if (!key) {
      return null;
    }

    const oldData = this.getPureStorage(key);
    if (!oldData) return null;
    window.localStorage.setItem(key, JSON.stringify({ ...oldData, ...value }));
  }

  public removeStorage(key: string) {
    if (!key) {
      return null;
    }

    window.localStorage.removeItem(key);
  }

  public getPureStorage(key) {
    if (!key) return null;
    try {
      return JSON.parse(window.localStorage.getItem(key) || '');
    } catch (e) {
      return null;
    }
  }
}

const storage = new Storage({
  version: VERSION,
});

export default storage;
